import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import "./admin_page.css"; // Írd meg itt a saját CSS-edet, vagy készíts egy admin.css fájlt
import { useSelector } from 'react-redux';

export function AdminTravelList() {
  const [travels, setTravels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const isAdmin = useSelector(state => state.permission.isAdmin);
  const url = process.env.REACT_APP_API_URL;

  // Utazások lekérése a backendből
  useEffect(() => {
    async function fetchTravels() {
      try {
        const response = await fetch(url + "/api/utazasok");
        if (!response.ok) {
          throw new Error("Nem sikerült lekérni az utazásokat.");
        }
        const data = await response.json();
        setTravels(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchTravels();
  }, []);

  // Törlés kezelése: a törlés után frissítjük az állapotot
  const handleDelete = async (id) => {
    if (window.confirm("Biztosan törli az adott utazást?")) {
      try {
        const response = await fetch(url + `/api/utazasok/${id}`, {
          method: "DELETE",
          credentials: "include"
        });
        if (!response.ok) {
          throw new Error("Nem sikerült törölni az utazást.");
        }
        // Frissítjük a listát: eltávolítjuk az adott elemet az állapotból
        setTravels(prev => prev.filter(travel => travel.id !== id));
      } catch (err) {
        alert(err.message);
      }
    }
  };

  if (!isAdmin) {
    return (
      <div className="error">
        Hozzáférés megtagadva. Csak adminisztrátorok számára elérhető.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loader-container">
        <BeatLoader color="#001662" size={30} loading={loading} aria-label="Loading Spinner" data-testid="loader" />
      </div>
    );
  }

  if (error) {
    return <div className="error">Hiba: {error}</div>;
  }

  return (
    <div className="admin-travel-list">
      <h1>Utazások Adminisztráció</h1>

      <div className="admin-actions">
        <button
          className="add-travel-btn"
          onClick={() => navigate("/travel_upload")}
        >
          Új utazás hozzáadása
        </button>
        <button
          className="add-travel-btn secondary"
          onClick={() => navigate("/admin/slider")}
        >
          Slider kezelése
        </button>
      </div>

      <div className="travel-list">
        {travels.map(travel => (
          <div key={travel.id} className="travel-card">
            <img 
              src={travel.image} 
              alt={travel.title} 
              className="travel-card-image"
            />
            <div className="travel-card-content">
              <h2>{travel.title}</h2>
              <p>{travel.date}</p>
            </div>
            <div className="travel-card-actions">
              <Link to={`/travel_edit/${travel.id}`} className="edit-btn">
                Szerkesztés
              </Link>
              <button className="delete-btn" onClick={() => handleDelete(travel.id)}>
                Törlés
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
